const styles = () => ({
  button: {
    float: 'right',
    maxHeight: '40px',
    padding: '5px',
    margin: '5px',
  },
});

export default styles;
